/**
 * Simple helper for login errors.
 *
 * File: \src\components\login\LoginErrorHelper.ts
 * Created Date: Sunday, July 5th 2020, 12:44:51
 * Author: Sascha Herrmann
 * -----
 * Last Modified: November 22nd 2024, 08:16:29
 * Modified By: Herrmann Sascha (LDC)
 * -----
 * Copyright (c) 2017-2020 Liebherr-Hausgeräte GmbH
 */
import { AccessCheckResponseRoleEnum } from '@/api/models';
import { useI18nStore } from '@/I18nStore';

/**
 * Resolves an login error into a human readable string for the error dialog.
 *
 * @export
 * @class LoginErrorHelper
 */
export default class LoginErrorHelper {
  // Pass this if terms of use were not accepted.
  public static readonly ERROR_TERMSOFUSE: string = 'ERROR_TERMSOFUSE';

  /**
   * Resolves a login error into a text for the user.
   *
   * @static
   * @param {(AccessCheckResponseRoleEnum | string)} reason The reason to display.
   * @returns {string} The string containing an (html) of the error.
   *
   * @memberof LoginErrorHelper
   */
  public static getErrorText(reason: AccessCheckResponseRoleEnum | string): string {
    const i18n = useI18nStore();

    if (reason === AccessCheckResponseRoleEnum.ERROR_NONLIEBHERRUSER) {
      return i18n.t('biz.home.loginerror.nonliebherrmessage');
    }

    if (reason === LoginErrorHelper.ERROR_TERMSOFUSE) {
      return i18n.t('biz.home.loginerror.unacceptedtermsofuse');
    }

    // Fall back
    return i18n.t('biz.home.loginerror.message');
  }
}
